import { m } from "framer-motion";
import { SHARED_ELEMENT } from "src/api/featureFlags";
import { SharedElementProps } from "./types";

const SharedElement = ({
	children,
	sharedElementId,
	width,
	height,
	enabled = true,
}: SharedElementProps) => {
	if (!enabled || !SHARED_ELEMENT) {
		return (
			<div
				style={{
					width,
					height,
				}}
			>
				{children}
			</div>
		);
	}
	return (
		<m.div
			layout
			layoutId={sharedElementId}
			style={{
				width,
				height,
			}}
		>
			{children}
		</m.div>
	);
};
export default SharedElement;
